<div class="staffing">
    @if (rolePermissionSelection) {
        <div class="role-selection">
            @for (userList of userLists; track $index) {
                <div
                    class="role-permission-button"
                    [class.active]="selectedPermissionIndex === $index"
                    [class.disabled]="userList.disabled"
                    [class.required]="userList.required"
                    [class]="getMessageTypes(userList)"
                    [attr.data-uiid]="dataUiid + '-role-permission-button-' + $index"
                    (click)="selectRolePermission($index)"
                >
                    <span class="role-permission-button-title">{{ userList.name }}</span>
                    <span class="role-permission-button-description">{{
                        userList.description
                    }}</span>
                    @if (userList.users.length === 0) {
                        <user-add-avatar [class]="getMessageTypes(userList)"></user-add-avatar>
                        @for (error of userList.messages; track $index) {
                            @if (error.errorText) {
                                <span class="error-message">{{ error.errorText }}</span>
                            }
                        }
                    } @else {
                        <cerrix-avatar-group
                            [userLists]="[userList]"
                            [disableTooltip]="true"
                            [dataUiid]="dataUiid"
                        ></cerrix-avatar-group>
                    }
                </div>
            }
        </div>
    }
    <mat-tab-group animationDuration="0ms" mat-stretch-tabs="false" mat-align-tabs="start">
        @if (editable) {
            <mat-tab labelClass="cerrix-mat-tab" label="Colleagues">
                <cerrix-selectable-user-list
                    [currentList]="userLists[selectedPermissionIndex]"
                    [users]="userLists[selectedPermissionIndex].selectableUsers"
                    (currentListChange)="userLists[selectedPermissionIndex] = $event"
                    [dataUiid]="dataUiid + '-selectable-user-list'"
                    [editable]="editable"
                ></cerrix-selectable-user-list>
            </mat-tab>
            <!-- <mat-tab label="Groups" disabled></mat-tab> -->
        }
        <mat-tab label="Selected">
            <cerrix-selectable-user-list
                [currentList]="userLists[selectedPermissionIndex]"
                [users]="getSelectedUsers()"
                [dataUiid]="dataUiid + '-selected-user-list'"
                (currentListChange)="userLists[selectedPermissionIndex] = $event"
                [editable]="editable"
            ></cerrix-selectable-user-list>
        </mat-tab>
    </mat-tab-group>
</div>
